export const mergeMessagesPage = (previousMessages, currentMessages, page) => {
  if (page === 0) return currentMessages

  const messagesById = new Map(
    previousMessages.map((message) => [message?._id, message])
  )

  currentMessages.forEach((message) => {
    messagesById.set(message?._id, message)
  })

  return [...messagesById.values()]
}
